function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createContext, useRef, useEffect, useContext, useState } from 'react';
import matchMedia from 'matchmediaquery';
import hyphenate from 'hyphenate-style-name';
import { shallowEqualObjects } from 'shallow-equal';
import PropTypes from 'prop-types';
var stringOrNumber = PropTypes.oneOfType([PropTypes.string, PropTypes.number]); // media types

var types = {
  all: PropTypes.bool,
  grid: PropTypes.bool,
  aural: PropTypes.bool,
  braille: PropTypes.bool,
  handheld: PropTypes.bool,
  print: PropTypes.bool,
  projection: PropTypes.bool,
  screen: PropTypes.bool,
  tty: PropTypes.bool,
  tv: PropTypes.bool,
  embossed: PropTypes.bool
}; // properties that match media queries

var matchers = {
  orientation: PropTypes.oneOf(['portrait', 'landscape']),
  scan: PropTypes.oneOf(['progressive', 'interlace']),
  aspectRatio: PropTypes.string,
  deviceAspectRatio: PropTypes.string,
  height: stringOrNumber,
  deviceHeight: stringOrNumber,
  width: stringOrNumber,
  deviceWidth: stringOrNumber,
  color: PropTypes.bool,
  colorIndex: PropTypes.bool,
  monochrome: PropTypes.bool,
  resolution: stringOrNumber,
  type: Object.keys(types)
}; // eslint-disable-next-line @typescript-eslint/no-unused-vars

var type = matchers.type,
    featureMatchers = _objectWithoutProperties(matchers, ["type"]); // media features


var features = _objectSpread({
  minAspectRatio: PropTypes.string,
  maxAspectRatio: PropTypes.string,
  minDeviceAspectRatio: PropTypes.string,
  maxDeviceAspectRatio: PropTypes.string,
  minHeight: stringOrNumber,
  maxHeight: stringOrNumber,
  minDeviceHeight: stringOrNumber,
  maxDeviceHeight: stringOrNumber,
  minWidth: stringOrNumber,
  maxWidth: stringOrNumber,
  minDeviceWidth: stringOrNumber,
  maxDeviceWidth: stringOrNumber,
  minColor: PropTypes.number,
  maxColor: PropTypes.number,
  minColorIndex: PropTypes.number,
  maxColorIndex: PropTypes.number,
  minMonochrome: PropTypes.number,
  maxMonochrome: PropTypes.number,
  minResolution: stringOrNumber,
  maxResolution: stringOrNumber
}, featureMatchers);

var all = _objectSpread(_objectSpread({}, types), features);

var mq = {
  all: all,
  types: types,
  matchers: matchers,
  features: features
};

var negate = function negate(cond) {
  return "not ".concat(cond);
};

var keyVal = function keyVal(k, v) {
  var realKey = hyphenate(k); // px shorthand

  if (typeof v === 'number') {
    v = "".concat(v, "px");
  }

  if (v === true) {
    return realKey;
  }

  if (v === false) {
    return negate(realKey);
  }

  return "(".concat(realKey, ": ").concat(v, ")");
};

var join = function join(conds) {
  return conds.join(' and ');
};

var toQuery = function toQuery(obj) {
  var rules = [];
  Object.keys(mq.all).forEach(function (k) {
    var v = obj[k];

    if (v != null) {
      rules.push(keyVal(k, v));
    }
  });
  return join(rules);
};

var Context = /*#__PURE__*/createContext(undefined);

var makeQuery = function makeQuery(settings) {
  return settings.query || toQuery(settings);
};

var hyphenateKeys = function hyphenateKeys(obj) {
  if (!obj) return undefined;
  var keys = Object.keys(obj);
  return keys.reduce(function (result, key) {
    result[hyphenate(key)] = obj[key];
    return result;
  }, {});
};

var useIsUpdate = function useIsUpdate() {
  var ref = useRef(false);
  useEffect(function () {
    ref.current = true;
  }, []);
  return ref.current;
};

var useDevice = function useDevice(deviceFromProps) {
  var deviceFromContext = useContext(Context);

  var getDevice = function getDevice() {
    return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
  };

  var _useState = useState(getDevice),
      _useState2 = _slicedToArray(_useState, 2),
      device = _useState2[0],
      setDevice = _useState2[1];

  useEffect(function () {
    var newDevice = getDevice();

    if (!shallowEqualObjects(device, newDevice)) {
      setDevice(newDevice);
    }
  }, [deviceFromProps, deviceFromContext]);
  return device;
};

var useQuery = function useQuery(settings) {
  var getQuery = function getQuery() {
    return makeQuery(settings);
  };

  var _useState3 = useState(getQuery),
      _useState4 = _slicedToArray(_useState3, 2),
      query = _useState4[0],
      setQuery = _useState4[1];

  useEffect(function () {
    var newQuery = getQuery();

    if (query !== newQuery) {
      setQuery(newQuery);
    }
  }, [settings]);
  return query;
};

var useMatchMedia = function useMatchMedia(query, device) {
  var getMatchMedia = function getMatchMedia() {
    return matchMedia(query, device || {}, !!device);
  };

  var _useState5 = useState(getMatchMedia),
      _useState6 = _slicedToArray(_useState5, 2),
      mq = _useState6[0],
      setMq = _useState6[1];

  var isUpdate = useIsUpdate();
  useEffect(function () {
    if (isUpdate) {
      // skip on mounting, it has already been set
      var newMq = getMatchMedia();
      setMq(newMq);
      return function () {
        if (newMq) {
          newMq.dispose();
        }
      };
    }
  }, [query, device]);
  return mq;
};

var useMatches = function useMatches(mediaQuery) {
  var _useState7 = useState(mediaQuery.matches),
      _useState8 = _slicedToArray(_useState7, 2),
      matches = _useState8[0],
      setMatches = _useState8[1];

  useEffect(function () {
    var updateMatches = function updateMatches(ev) {
      setMatches(ev.matches);
    };

    mediaQuery.addListener(updateMatches);
    setMatches(mediaQuery.matches);
    return function () {
      mediaQuery.removeListener(updateMatches);
    };
  }, [mediaQuery]);
  return matches;
};

var useMediaQuery = function useMediaQuery(settings, device, onChange) {
  var deviceSettings = useDevice(device);
  var query = useQuery(settings);
  if (!query) throw new Error('Invalid or missing MediaQuery!');
  var mq = useMatchMedia(query, deviceSettings);
  var matches = useMatches(mq);
  var isUpdate = useIsUpdate();
  useEffect(function () {
    if (isUpdate && onChange) {
      onChange(matches);
    }
  }, [matches]);
  useEffect(function () {
    return function () {
      if (mq) {
        mq.dispose();
      }
    };
  }, []);
  return matches;
}; // ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return


var MediaQuery = function MediaQuery(_ref) {
  var children = _ref.children,
      device = _ref.device,
      onChange = _ref.onChange,
      settings = _objectWithoutProperties(_ref, ["children", "device", "onChange"]);

  var matches = useMediaQuery(settings, device, onChange);

  if (typeof children === 'function') {
    return children(matches);
  }

  return matches ? children : null;
};

export { Context, MediaQuery as default, toQuery, useMediaQuery };